import { MCP_AGENT_CODRIVER } from 'site-modules/shared/constants/mcp/agents';

/**
 * Maps an MCP app path (i.e. the `agent` segment of the `/api/venom/mcp/:agent` URL) to the `synpartner`
 * value expected by analytics. Providers not listed here fall back to their raw agent name.
 */
const MCP_AGENT_SYNPARTNER_MAP = {
  [MCP_AGENT_CODRIVER]: 'co-driver',
};

export function getMcpSynpartner(mcpAgent) {
  return MCP_AGENT_SYNPARTNER_MAP[mcpAgent] || mcpAgent;
}
